module.exports = __webpack_public_path__ + "img/music.04500bee.svg";